<template>
  <div>
    <div
      v-for="subaccountInvite of subaccountInvites"
      :key="subaccountInvite.parent_organization_id"
      class="invitation-notification"
    >
      <expand-transition>
        <sb-panel
          variation="info"
          icon-orientation="start"
          class="invite-banner"
        >
          <div class="invite-banner-container">
            <div class="invite-banner-left-container">
              <div class="vertical-line" />
              <div class="invite-banner-content">
                <span class="bold-text">
                  {{ `${$t('title')} ${subaccountInvite.business_name} account.` }}
                </span>
                <br>
                <span>
                  {{ `${$t('subTitle')} ${subaccountInvite.expiryDay} days if not accepted.` }}
                </span>
              </div>
            </div>
            <sb-button @click.prevent="handleInviteClick(subaccountInvite.parent_organization_id)">
              {{ $t('buttonText') }}
            </sb-button>
          </div>
        </sb-panel>
      </expand-transition>
    </div>
  </div>
</template>
<script>

import MembershipService from '@/services/membership/membership.service'

export default {
  name: 'SubaccountInvitationBanner',
  data () {
    return {
      subaccountInvites: []
    }
  },
  async mounted () {
    const oneIdClaim = this.$shipBobStore.getters['user/getOneIdClaim']
    const organizationId = oneIdClaim.Lorg
    const organizationType = oneIdClaim.lorg_type
    const merchantOrgType = '4fd26cc1-36ee-42ea-ba05-d38a369e35f6'
    let organization = null
    const isToggleOn = false

    const response = await MembershipService.getOrganization(organizationId)

    if (response.success) {
      organization = response.data
    }

    if (organization != null &&
        organizationType === merchantOrgType &&
        organization.parent_organization_id == null && isToggleOn) {
      const response = await MembershipService.getSubaccountInvites(organizationId)

      if (response.success) {
        this.subaccountInvites = response.data
        this.subaccountInvites?.forEach((invite) => {
          invite.expiryDay = this.setExpiryInDays(invite)
        })
        this.subaccountInvites = this.subaccountInvites.filter((invite) => invite.expiryDay > 0)
      }
    }
  },
  methods: {
    handleInviteClick (subaccountInviteOrgId) {
      this.$router.push({ path: `/user-management/company-profile?selectedInviteParentOrgId=${subaccountInviteOrgId}` })
    },
    convertToUTC (date) {
      return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds())
    },
    setExpiryInDays (invite) {
      const currentDate = this.convertToUTC(new Date())
      const expiredDate = new Date(invite.expiration_date)
      return Math.ceil((expiredDate - currentDate) / (1000 * 60 * 60 * 24))
    }
  },
  i18n: {
    messages: {
      'en-US': {
        title: 'You have an invitation to join the ',
        subTitle: 'Review the invitation details to accept or reject. The invitation expires in',
        buttonText: 'Review Invitation'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/banner';

.invitation-notification {
  width: calc(100% - 2rem);
  margin-left: 1rem;

  .invite-banner {
    align-items: center;
    margin-top: 0.5rem;

    .invite-banner-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .invite-banner-left-container {
        display: flex;
        max-width: 75%;

        .bold-text {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
